<mat-spinner *ngIf="mode==='circle'" [class]="cls" [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>

<div *ngIf="mode==='block'" class="lds-facebook">
  <div [ngStyle]="{'background':color}"></div>
  <div [ngStyle]="{'background':color}"></div>
  <div [ngStyle]="{'background':color}"></div>
</div>